import axios from 'axios';

export const state = {
   purchases: []
}

export const getters = {
   purchases: state => state.purchases
}

export const mutations = {
   setPurchases(state, newValue){
      state.purchases = newValue
   }
}

export const actions = {
   async fetchPurchases({commit}){
      await axios.get('purchases').then(res=>{
         commit('setPurchases', res.data.purchases);
      })
   }
}